import { ActionCreatorWithPayload, createSelector, EntitySelectors, Update } from '@reduxjs/toolkit';
import { GiftJson } from '@ff-scene-plugins/gift-shared/GiftJson';

export const bindInputUpdaterFactory = (
    updateInput: ActionCreatorWithPayload<readonly Update<GiftJson.Input<any>>[]>
) => {
    return ({
        to: <TOptions>() => {
            return <K extends keyof TOptions>(key: K) => {
                return (ids: string[], value: TOptions[K]) => {
                    return updateInput(ids.map(id => ({
                        id, changes: { [key]: value }
                    })));
                };
            };
        }
    });
};

export const bindInputSelectorFactory = <TState>(
    selectors: EntitySelectors<GiftJson.Input<any>, TState>
) => {
    return ({
        to: <TInput>() => {
            return <T>(selector: (i: TInput) => T) => {
                return createSelector(selectors.selectById, i => i !== undefined
                    ? selector(i.value)
                    : undefined);
            };
        }
    });
};